<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title"> {{ editMode ? 'Update' : 'Add' }}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"
        (keydown.enter)="$event.preventDefault()"></button>
</div>
<div class="modal-body">
  <div class="col-12">
      <div class="card" [formGroup]="addForm">
          <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label class="form-label" for="chargetype">Charges for<span
                                        class="mandatory">*</span></label>
                                <ng-select id="chargetype" [items]="typeList" formControlName="ddlType" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    bindLabel="name" [bindValue]="'name'" placeholder="Select" aria-required="true"
                                    (change)="onChangeChargeType()"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || addForm.get('ddlType')?.touched) && addForm.get('ddlType').errors}">
                                </ng-select>
                                <div *ngIf="(isFormSubmitted || addForm.get('ddlType')?.touched) && addForm.get('ddlType').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="addForm.get('ddlType').errors.required">Charge Type is
                                        required</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3" *ngIf="this.CustomerType == true">
                                <div class="mb-2">
                                    <label class="form-label" for="customer">Customer<span
                                            *ngIf="addForm.get('ddlType').value==='Customer'"
                                            class="mandatory">*</span></label>
                                    <ng-select id="customer" [items]="customerList" formControlName="ddlCustomer" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                        bindLabel="name" [bindValue]="'id'" placeholder="Select"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || addForm.get('ddlCustomer')?.touched) && addForm.get('ddlCustomer').errors}">
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || addForm.get('ddlCustomer')?.touched) && addForm.get('ddlCustomer').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="addForm.get('ddlCustomer').errors.required">Customer is
                                            Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label class="form-label" for="vendor">Vendor<span
                                            *ngIf="addForm.get('ddlType').value==='Vendor'"
                                            class="mandatory">*</span></label>
                                    <ng-select id="vendor" [items]="vendorList" formControlName="ddlVendor" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                        bindLabel="name" [bindValue]="'id'" placeholder="Select" (change)="bindService()"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || addForm.get('ddlVendor')?.touched) && addForm.get('ddlVendor').errors}">
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || addForm.get('ddlVendor')?.touched) && addForm.get('ddlVendor').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="addForm.get('ddlVendor').errors.required">Vendor is
                                            Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label class="form-label" for="service">Service</label>
                                    <ng-select id="service" [items]="serviceList" formControlName="ddlService" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                        bindLabel="servicename" [bindValue]="'id'" placeholder="Select">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header bg-transparent border-bottom text-uppercase">Destination</div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="country" class="form-label">Country <span class="mandatory">*</span></label>
                                <ng-select id="country" placeholder="Select" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    (change)="onCountryChange()" [items]="countryList" bindLabel="name"
                                    [bindValue]="'isocode'" formControlName="ddlCountry"
                                    [ngClass]="{'is-invalid': (isFormSubmitted || addForm.get('ddlCountry')?.touched) && addForm.get('ddlCountry').errors}">
                                </ng-select>
                                <div *ngIf="(isFormSubmitted || addForm.get('ddlCountry')?.touched) && addForm.get('ddlCountry').errors"
                                    class="invalid-feedback">
                                    <span *ngIf="addForm.get('ddlCountry').errors.required">Country is required</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="state" class="form-label">State</label>
                                <ng-select id="state" placeholder="Select"  [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    (change)="onStateChange()" [items]="stateList" bindLabel="name"
                                    [bindValue]="'isocode'" formControlName="ddlState">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="city" class="form-label">City</label>
                                <ng-select id="city" placeholder="Select" [items]="cityList" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                    bindLabel="name" [bindValue]="'isocode'" formControlName="ddlCity">
                                </ng-select>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="mb-2">
                                <label for="pincode" class="form-label">Pincode</label>
                                    <input formControlName="txtPincode" type="text"
                                        class="form-control col form-control-sm" placeholder="Type to search"
                                        [minlength]="minPincode" [maxlength]="maxPincode" [ngbTypeahead]="searchPincode"
                                        [resultTemplate]="pt" [inputFormatter]="pincodeFormatter"
                                        (ngModelChange)="onPincodeChanged()" (keydown)="setPincodeValidation()"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || addForm.get('txtPincode')?.touched) && addForm.get('txtPincode').errors}" />
                                    <ng-template #pt let-p="result" let-t="term">
                                        <ngb-highlight [result]="p.pincode" [term]="t"></ngb-highlight>
                                        <!-- <span> | {{r['code']}}</span> -->
                                    </ng-template>
                                    <div *ngIf="(isFormSubmitted || addForm.get('txtPincode')?.touched) && addForm.get('txtPincode').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="addForm.get('txtPincode').errors.pattern">Invalid Pincode.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="taxSwitch" class="form-label">ODA Applicable</label>
                                    <div class="form-check form-switch form-switch-md mb-2">
                                        <input type="checkbox" id="taxSwitch" class="form-check-input"
                                            formControlName="txtODASwitch">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="fuelSwitch" class="form-label">Serviceable</label>
                                    <div class="form-check form-switch form-switch-md mb-2">
                                        <input type="checkbox" id="fuelSwitch" class="form-check-input"
                                            formControlName="txtServiceableSwitch">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="upsert()" (keydown.enter)="upsert()"> {{ editMode ?
        'Update' : 'Add' }}</button>
</div>